export const baseUrl = "https://properana.onrender.com";
